import { useEffect, useState } from 'react';

/**
 * Compte à rebours en secondes (bouton « Renvoyer le code »).
 *
 * `setInterval`, pas un `setTimeout` rearmé à chaque tick dans l'effet : avec
 * les minuteurs factices de test, un `setTimeout` rearmé exige un flush d'effet
 * React ENTRE deux ticks pour reprogrammer le suivant, donc un seul avancement
 * de l'horloge (`advanceTimersByTime`) ne fait descendre le compteur que d'un
 * cran, même sur une grande durée. L'intervalle, lui, est déjà réarmé côté
 * horloge factice et déclenche tous ses tics dans un seul avancement.
 */
export function useCountdown() {
    const [secondsLeft, setSecondsLeft] = useState(0);
    const isRunning = secondsLeft > 0;

    useEffect(() => {
        if (!isRunning) return undefined;
        const timer = setInterval(() => setSecondsLeft((s) => Math.max(0, s - 1)), 1000);
        return () => clearInterval(timer);
    }, [isRunning]);

    return { secondsLeft, start: (seconds: number) => setSecondsLeft(seconds) };
}
